import Vue from 'vue'
import Router from 'vue-router'

import home from './home/home'
import read from './read/read'
import form from './form/form'
import formLatest from './form/form-latest'
import formV3 from './form/form-v3'
import v2 from './v2/v2'
import cc from './cc/cc'
import monitor from './monitor/monitor'
import signup from './signup/signup'
import signin from './signin/signin'
import a4Form from './a4form/a4form'
import cleaner from './cleaner/cleaner'
import report from './report/report'
import schedule from './schedule/schedule'
import pl_cleaner from './pl_cleaner/pl_cleaner'
import business_form from './business_form/business_form'
import business_form_1009 from './business_form_1009/business_form_1009'
import all_stocks from './all_stocks/all_stocks'
import room_stocks from './all_stocks/room_stocks'
import sup_tasks from './sup_tasks/sup_tasks'
import employee from './employee/employee'
import rooms from './room/list'
import analysis from './analysis/analysis'
import signup_employee from './signup_employee/signup_employee'
import att_table from './att_table/att_table.vue'
import print_form from './form/print_form.vue'
import room_stats from './room/room_stats.vue'
import logo from './logo/logo.vue'
import ownerShell from './owner/shell.vue'
import ownerDashboard from './owner/dashboard.vue'
import ownerMock from './owner/mock.vue'
import ownerProfile from './owner/profile.vue'
import ownerSettlement from './owner/settlement.vue'
import ownerContract from './owner/contract.vue'
import plLandlordList from './pl_landlord/list.vue'
import plLandlordMock from './pl_landlord/mock.vue'
import plLandlordFacility from './pl_landlord/facility.vue'
import plLandlordOverview from './pl_landlord/overview.vue'
import plLandlordStayTax from './pl_landlord/stay-tax.vue'
import plLandlordSettlementEdit from './pl_landlord/settlement-edit.vue'
import plLandlordOwnerStayQueue from './pl_landlord/owner-stay-queue.vue'

import './style.css'


Vue.use(Router)
const router = new Router({
  base: location.href.indexOf('localhost:8000') > -1 ? '/' : '/report',
  mode: 'hash',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      window.lastPosition = savedPosition;
      return savedPosition
    } else {
      window.lastPosition = {
        x: 0,
        y: 0
      };
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [{
    path: '',
    redirect: '/logo'
  },
  {
    name: 'logo',
    path: '/logo',
    component: logo,
    pc: false,
  },
  {
    name: 'working_report',
    path: '/working_report',
    component: home,
    pc: false,
  },
  {
    name: 'read',
    path: '/read',
    component: read,
    pc: false,
  },
  {
    name: 'form-latest',
    path: '/form-latest',
    component: formLatest,
    pc: false,
  },
  {
    name: 'form-v3',
    path: '/form-v3',
    component: formV3,
    pc: false,
  },
  {
    name: 'form',
    path: '/form',
    component: form,
    pc: false,
  },
  {
    name: 'a4form',
    path: '/a4form',
    component: a4Form,
    pc: false,
  },
  {
    name: 'monitor',
    path: '/monitor',
    component: monitor,
    pc: true,
  },
  {
    name: 'cc',
    path: '/cc',
    component: cc,
    pc: true,
  },
  {
    name: 'v2',
    path: '/v2',
    component: v2,
    pc: true,
  },
  {
    name: 'signup',
    path: '/signup',
    component: signup,
    pc: false,
  },
  {
    name: 'signup_employee',
    path: '/signup_employee',
    component: signup_employee,
    pc: false,
  },
  {
    name: 'signin',
    path: '/signin',
    component: signin,
    pc: false,
  },
  {
    name: 'cleaner',
    path: '/cleaner',
    component: cleaner,
    pc: false,
  },
  {
    name: 'employee',
    path: '/employee',
    component: employee,
    pc: false,
  },
  {
    name: 'report',
    path: '/report',
    component: report,
    pc: false,
  },
  {
    name: 'schedule',
    path: '/schedule',
    component: schedule,
    pc: true,
  },
  {
    name: 'pl_cleaner',
    path: '/pl_cleaner',
    component: pl_cleaner,
  },
  {
    name: 'pl_employee',
    path: '/pl_employee',
    component: pl_cleaner,
    pc: true,
  },
  {
    name: 'business_form',
    path: '/business_form',
    component: business_form,
    pc: false,
  },
  {
    name: 'business_form_1009',
    path: '/business_form_1009',
    component: business_form_1009,
    pc: false,
  },
  {
    name: 'all_stocks',
    path: '/all_stocks',
    component: all_stocks,
    pc: true,
  },
  {
    name: 'room_stocks',
    path: '/room_stocks',
    component: room_stocks,
    pc: true,
  },
  {
    name: 'sup_tasks',
    path: '/sup_tasks',
    component: sup_tasks,
    pc: true,
  },
  {
    name: 'rooms',
    path: '/rooms',
    component: rooms,
    pc: true,
  },
  {
    name: 'room_stats',
    path: '/room_stats',
    component: room_stats,
    pc: true,
  },
  {
    name: 'analysis',
    path: '/analysis',
    component: analysis,
    pc: true,
  },
  {
    name: 'att_table',
    path: '/att_table',
    component: att_table,
    pc: true,
  },
  {
    name: 'print_form',
    path: '/print_form',
    component: print_form,
    pc: true,
  },
  {
    path: '/owner',
    component: ownerShell,
    pc: true,
    children: [
      {
        name: 'owner',
        path: '',
        component: ownerDashboard,
        pc: true,
      },
      {
        name: 'owner-mock',
        path: 'mock',
        component: ownerMock,
        pc: true,
      },
      {
        name: 'owner-profile',
        path: 'profile',
        component: ownerProfile,
        pc: true,
      },
      {
        name: 'owner-settlement',
        path: 'settlement',
        component: ownerSettlement,
        pc: true,
      },
      {
        name: 'owner-contract',
        path: 'contract',
        component: ownerContract,
        pc: true,
      },
    ],
  },
  {
    name: 'pl_landlord',
    path: '/pl_landlord',
    component: plLandlordList,
    pc: true,
  },
  {
    name: 'pl_landlord-mock',
    path: '/pl_landlord_mock',
    component: plLandlordMock,
    pc: true,
  },
  {
    name: 'pl_landlord-facility',
    path: '/pl_landlord_facility',
    component: plLandlordFacility,
    pc: true,
  },
  {
    name: 'pl_landlord-overview',
    path: '/pl_landlord_overview',
    component: plLandlordOverview,
    pc: true,
  },
  {
    name: 'pl_landlord-stay-tax',
    path: '/pl_landlord_stay_tax',
    component: plLandlordStayTax,
    pc: true,
  },
  {
    name: 'pl_landlord-settlement',
    path: '/pl_landlord_settlement',
    component: plLandlordSettlementEdit,
    pc: true,
  },
  {
    name: 'pl_landlord-owner-stay',
    path: '/pl_landlord_owner_stay',
    component: plLandlordOwnerStayQueue,
    pc: true,
  },
  ],
})

function isOwnerGuardedPath(path) {
  if (!path || path.indexOf('/owner') !== 0) {
    return false;
  }
  if (path === '/owner/mock' || path.indexOf('/owner/mock') === 0) {
    return false;
  }
  return true;
}

router.beforeEach(function (to, from, next) {
  if (!isOwnerGuardedPath(to.path)) {
    next();
    return;
  }
  var landlord = null;
  try {
    landlord = JSON.parse(localStorage.getItem('_landlord') || 'null');
  } catch (e) {
    landlord = null;
  }
  if (!landlord || !landlord.token) {
    next({ path: '/signin', replace: true });
    return;
  }
  if (typeof axios !== 'undefined') {
    axios.defaults.headers.common['Token'] = landlord.token;
  }
  next();
});

export default router